export default __webpack_public_path__ + "static/media/sme.0b0ce6a1.jpg";